module.exports = __webpack_public_path__ + "static/img/3.da14a934.png";